module.exports = __webpack_public_path__ + "static/img/13.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/13.png
// module id = 0v4m
// module chunks = 0